<div class="title p-2">
    <div class="row">
        <div class="col d-flex justify-content-start">
            <h1 class="mx-1">Generează un document</h1>

        </div>
        <div class="col d-flex justify-content-end">
            <button type="button" class="action-btn" (click)="closeDialog()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
</div>


<div class="row p-2">
    <div class="col">
        <form [formGroup]="form" (ngSubmit)="submitDocumentGenerabil()">
            <!-- Only for data type 1 -->
            <div *ngIf="data.type == 1" class="row p-1">
                <div class="col-md-6">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>Cod CAEN</mat-label>
                        <input matInput type="number" formControlName="obiect_activitate" />
                    </mat-form-field>
                </div>
                <div class="col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Valabilitate</mat-label>
                        <input matInput [matDatepicker]="pickerValabil" formControlName="valability" readonly
                            (focus)="pickerValabil.open()" (dateChange)="onDateChange($event)" />
                        <mat-hint>ZZ/LL/AAAA</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="pickerValabil"></mat-datepicker-toggle>
                        <mat-datepicker #pickerValabil></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
            <!-- For all data types -->
            <div class="row p-1">
                <div class="col">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>Template</mat-label>
                        <mat-select formControlName="template_id" (selectionChange)="onTemplateChange($event.value)">
                            <mat-option *ngFor="let row of templates$ | async" [value]="row.id">
                                {{ row.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <ng-container *ngIf="template?.document_generabil_dual">
                <div>
                    <mat-button-toggle-group name="fontStyle" aria-label="Font Style"
                        (change)="onDestinatieChange($event)" value="toPrimarie">
                        <mat-button-toggle value="toPrimarie">Exemplar Semnatari</mat-button-toggle>
                        <mat-button-toggle value="toCetatean">Exemplar Cetățean</mat-button-toggle>
                        <mat-button-toggle value="toate">Toate</mat-button-toggle>
                    </mat-button-toggle-group>
                </div>
                <br />
            </ng-container>
            <ng-container *ngIf="template">
                <div class="row">
                    <div class="col" *ngIf="destination == 'toPrimarie' || destination == 'toate'">
                        <br />
                        <div class="col">
                            <h2 class="fw-bold">Exemplar Semnatari</h2>
                            <br />
                            <angular-editor class="fit-screen" formControlName="content"
                                [config]="editorConfig"></angular-editor>
                        </div>
                    </div>
                    <div class="col" *ngIf="destination == 'toCetatean' || destination == 'toate'">
                        <br />
                        <div class="col">
                            <h2 class="fw-bold">Exemplar Primar</h2>
                            <br />
                            <angular-editor class="fit-screen" formControlName="content_citizen"
                                [config]="editorConfig"></angular-editor>
                        </div>
                    </div>
                </div>
            </ng-container>

            <br />

            <div class="row mt-2">
                <div class="col">
                    <div class="col d-flex justify-content-end">
                        <button class="buttons" mat-flat-button color="primary" type="submit" [disabled]="form.invalid">
                            {{ helper.dialogConfig.buttonLabels.save }}
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>

    <div class="section-spinner" *ngIf="isLoading"
        style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.5);">
        <div class="spinner" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>